import { useContext, useEffect, useState } from 'react';
import { Progress } from 'reactstrap';
import './AttachFile.scss'

import { uploadFile } from '../../../../../utils/uploadFile';
import { Option } from '../common/OptionInput';
import { ChooseURL } from './ChooseURL';
import DraggableUpload from './DraggableUpload';

import CloseCross from '../../../../../assets/images/closeCross';
import FileICON from "../../../../../assets/images/file.svg";
import { UserContext } from '../../../../../context/userContext';

const delay = (duration) => {
  return new Promise(resolve => setTimeout(resolve, duration));
}

export const File = ({ file, setFile }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
  const { userID, sessionID } = useContext(UserContext);
  const [message, setMessage] = useState(null);

  const handleClose = () => {
    setFile(null);
  }

  useEffect(() => {
    if (file && !file.fileId) {
      setIsLoaded(false);
      setProgress(0);
    }
  }, [file]);

  const handleUpload = async () => {
    setIsUploading(true);
    setIsLoaded(false);
    const uploadedFile = await uploadFile(file, userID, sessionID, setProgress);
    if (uploadedFile && uploadedFile.status == 'success') {
      await delay(1000)
      setMessage(uploadedFile.msg)
      setFile({ name: file.name, size: file.size, fileId: uploadedFile.fileId })
      setIsLoaded(true);
      await delay(3000)
    }
    setMessage(null);
    setIsUploading(false);
  }

  if (file)
    return (
      <>
        <div className='file fade-in'>
          <div className='file_preview'>
            <img src={FileICON} />
            <div>
              {file.name}
              <span>{(`${file.size}` / 1048576).toFixed(2) + " MB"}</span>
              {!isLoaded && <Progress value={progress} />}
            </div>
            {!isLoaded && <CloseCross onClick={handleClose} />}
          </div>
          {!isLoaded && <button className={isUploading ? "disabled" : ""} onClick={handleUpload}>Upload</button>}
        </div>
        {message && <div className='message success fade-in'>{message}</div>}
      </>
    )
}


export const AttachFile = ({ onTypeChange, type, onLinkChange }) => {
  const [file, setFile] = useState(null);

  return (
    <>
      <Option
        id="attachFile"
        checked={type}
        onChange={onTypeChange}
        text="Attach a file"
        value="attach"
        name="link"
      />
      {type == "attach" &&
        <div className='attach_file_container'>
          <b>Upload files</b>
          <DraggableUpload setFile={setFile} />
          <File file={file} setFile={setFile} />
          <ChooseURL file={file} onLinkChange={onLinkChange} />
        </div>
      }
    </>
  )
}
